import { useAppQuery } from '@/helpers/api/query'

import { createInstance } from '@/helpers/api/base'
import { Garage } from '@/types/garage'

const GET_GARAGES_KEY = 'GET_GARAGES'

export const useGetGarages = () =>
    useAppQuery<Garage[]>({
        queryKey: [GET_GARAGES_KEY],
        queryFn: () =>
            createInstance({
                url: '/garages',
                method: 'GET',
            }),
        staleTime: Infinity,
    })
